export default `
query FORM($serviceId: Int!, $customerId: Int!, $frequencyIds: String!) {
  form(serviceId: $serviceId, customerId: $customerId, frequencyIds: $frequencyIds) {
    id
    name
    schema
  }
}
`
